export default function LinkShortener() {
  return <div style={{ padding: 24 }}><h2>LinkShortener - Coming Soon</h2></div>;
}
